import { Box, Text } from '@bechtel/gds';
import { FC } from 'react';
import { UnderConstruction } from '~/components/under-construction';
import { FeaturesContainer } from './styled';

export const Features: FC = () => {
  return (
    <FeaturesContainer>
      <Box>
        <Text family="openSansSemiBold" weight="600" size="500" color="neutral.800">
          Features
        </Text>
      </Box>
      <UnderConstruction></UnderConstruction>
    </FeaturesContainer>
  );
};
